import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-939d98ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Run a benchmark from Geekbench", -1))
const _hoisted_3 = { style: {"display":"flex","justify-content":"space-between","align-items":"end"} }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        type: "url",
        pattern: "https://browser.geekbench.com/.*",
        class: _normalizeClass(["search-input", _ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light']),
        onInput: _cache[0] || (_cache[0] = (e) => _ctx._invalidUrl(e)),
        placeholder: "Type a valid Geekbench URL",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.geekbenchUrl) = $event))
      }, null, 34), [
        [_vModelText, _ctx.geekbenchUrl]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('back'))),
        class: "cancel"
      }, "Back"),
      _createElementVNode("button", {
        disabled: _ctx.invalidUrl,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('confirm', _ctx.geekbenchUrl))),
        class: "confirm"
      }, "Confirm", 8, _hoisted_4)
    ])
  ]))
}